module.exports = __webpack_public_path__ + "static/1@3x-456758c9f34174f7b82e30e02817a73e.png";